import {navigator} from 'global';

const jsclients = jsclient;     /* Get this function from fsclient.js from jsp */
let device_type='';

//Code for getting device type
if(navigator.userAgent.match(/iPad/i)){
	device_type='Tablet';
}
else if(navigator.userAgent.match(/mobile/i)){
	device_type='Mobile';
}
else if(navigator.userAgent.match(/iPad|Android|Touch/i)){
	device_type='Tablet';
}
else{
	device_type='Desktop';
}

export const _client={
    getOs:function (){
        return jsclients.os;
    },
    getOsVersion:function (){
        return jsclients.osVersion;
    },
    getBrowser:function(){
        return jsclients.browser
    },
    getBrowserVersion:function(){
        return jsclients.browserVersion;
    },
    getBrowserMajorVersion:function(){
        return jsclients.browserMajorVersion;
    },
    getDevicetype:function(){
        return device_type;
    },
    getCookieStatus:function(){
        return jsclients.cookies;
    },
    getScreenSize:function(){
        return jsclients.screen;
    }
};
